'use client'

import { formatGermanNumber } from '@utils/utils-format'

import { useExperienceFilterContext } from '../_components/app-experience-filter-provider'
import { useExperienceOptions } from './use-app-experience-options'
import { useExperiencePriceCategoryName } from './use-app-experience-price-category-name'
import type { PurchasableDay } from './use-app-experience-purchasable-days'

export function useAppTicketSelection() {
  const { experience, filter } = useExperienceFilterContext()
  const { allOptions } = useExperienceOptions(experience.variants)
  const getExperiencePriceCategoryName = useExperiencePriceCategoryName()

  const selectedTickets = allOptions
    .map(option => ({
      option,
      count: filter.selectedOptions?.[option.id] ?? 0,
      categoryName: getExperiencePriceCategoryName(option.name),
    }))
    .filter(entry => entry.count > 0)

  const totalCount = selectedTickets.reduce((sum, entry) => sum + entry.count, 0)
  const total = selectedTickets.reduce((sum, entry) => sum + entry.count * entry.option.price, 0)

  const [onlyTicket] = selectedTickets

  let ticketsLabel: string
  if (selectedTickets.length === 1 && onlyTicket) {
    ticketsLabel = `${onlyTicket.count} x ${onlyTicket.categoryName}`
  } else {
    ticketsLabel =
      totalCount === 1
        ? `${formatGermanNumber(totalCount)} Eintrittskarte`
        : `${formatGermanNumber(totalCount)} Eintrittskarten`
  }

  const ticketsBreakdown = selectedTickets
    .map(entry => `${entry.count} x ${entry.categoryName}`)
    .join(', ')

  return { selectedTickets, totalCount, total, ticketsLabel, ticketsBreakdown }
}

export function useOpeningHoursLabel() {
  return (day: PurchasableDay | null) =>
    day?.windows
      .map(window => `${window.from.slice(0, 5)} - ${window.to.slice(0, 5)} Uhr`)
      .join(' · ') ?? ''
}
